import Axios from 'axios';
import React, { useEffect, useState } from 'react';

import { isModuleEnabled } from '@strongio/pretrained-dashboard/modules';
import ErrorAlert from '@strongio/pretrained-dashboard/components/ErrorAlert';
import LoadingOverlay from '@strongio/pretrained-dashboard/components/LoadingOverlay';

function SocialAuthInternal() {
  const [loading, setLoading] = useState(true);
  const [apiError, setApiError] = useState(null);
  const [authProviders, setAuthProviders] = useState([]);

  useEffect(() => {
    Axios.get('/api/sso/providers').
    then((response) => setAuthProviders(response.data)).
    catch((e) => setApiError(e)).
    finally(() => setLoading(false));
  }, []);

  return /*#__PURE__*/(
    React.createElement("div", { className: "mt-6" }, /*#__PURE__*/
    React.createElement("div", { className: "relative" }, /*#__PURE__*/
    React.createElement("div", { className: "absolute inset-0 flex items-center" }, /*#__PURE__*/
    React.createElement("div", { className: "w-full border-t border-gray-300" })), /*#__PURE__*/

    React.createElement("div", { className: "relative flex justify-center text-sm leading-5" }, /*#__PURE__*/
    React.createElement("span", { className: "px-2 bg-white text-gray-500" }, "Or continue with"))), /*#__PURE__*/





    React.createElement(ErrorAlert, { error: apiError, clearError: setApiError }), /*#__PURE__*/

    React.createElement("div", { className: "mt-6 grid grid-cols-3 gap-3 relative" },
    loading ? /*#__PURE__*/React.createElement(LoadingOverlay, null) :
    authProviders.map((authProvider) => /*#__PURE__*/
    React.createElement("div", { key: authProvider.slug }, /*#__PURE__*/
    React.createElement("a", {
      href: authProvider.url,
      className: "w-full inline-flex justify-center py-2 px-4 border border-gray-300 rounded-md shadow-sm bg-white text-sm font-medium text-gray-500 hover:bg-gray-50" }, /*#__PURE__*/

    React.createElement("span", { className: "sr-only" }, "Sign in with",

    authProvider.name), /*#__PURE__*/

    React.createElement("img", { src: authProvider.favicon, alt: authProvider.name, className: "w-5 h-5" })))))));






}

export default function SocialAuth() {
  if (isModuleEnabled('sso')) {
    return /*#__PURE__*/React.createElement(SocialAuthInternal, null);
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null);
}